
import "../../css/components/Core/ProjectCards.css";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Card, CardActions, Grid, CardContent, Typography, Box } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const CreateProjectCard = ({ workspaceId }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCreateNewProject = () => {
    navigate(`/workflow/workspace/${workspaceId}/projects/new`);
  }

  return (
    <Grid item xs={12} sm={6} md={4} className="sortable-project-landing-page">
      <Card className="project-cards-card create-project-card" onClick={handleCreateNewProject}>
        <CardContent className="create-project-card-content">
          <AddRoundedIcon className="create-project-card-icon" style={{ fontSize: 200 }} />
        </CardContent>
        <CardActions className="create-project-card-actions">
          <Box className="project-cards-actions-box create-title-box">
            <Typography variant="h6" component="div" className="create-project-card-title">
              {t('main_page.new_project')}
            </Typography>
          </Box>
        </CardActions>
      </Card>
    </Grid>
  );
};

export default CreateProjectCard;